<script setup lang="ts">
  import { IconRadio } from '@/shared/ui';
  import type { BranchMember } from '@/entities/Branch';
  import TrainingMinistrantesSection from '../TrainingMinistrantesSection.vue';
  import OpenTrainingExternalIndividualSection from './OpenTrainingExternalIndividualSection.vue';
  import OpenTrainingExternalCompanySection from './OpenTrainingExternalCompanySection.vue';
  import type { useOpenTrainingInstructor } from '../../model/useOpenTrainingInstructor';

  defineProps<{
    instructor: ReturnType<typeof useOpenTrainingInstructor>;
    members: BranchMember[];
    memberOptions: { id: number; name: string }[];
  }>();
</script>

<template>
  <div class="flex flex-col gap-3 border-b border-gray-02 px-6 py-8">
    <span
      id="open-training-instructor-label"
      class="text-sm font-semibold text-gray-07"
    >Ministrante</span>
    <div
      class="flex gap-8"
      aria-labelledby="open-training-instructor-label"
    >
      <IconRadio
        data-testid="open-training-instructor-internal"
        :model-value="instructor.mode.value ?? undefined"
        value="INTERNAL"
        label="Interno"
        name="open-training-instructor-mode"
        @update:model-value="instructor.setMode('INTERNAL')"
      />
      <IconRadio
        data-testid="open-training-instructor-external"
        :model-value="instructor.mode.value ?? undefined"
        value="EXTERNAL"
        label="Externo"
        name="open-training-instructor-mode"
        @update:model-value="instructor.setMode('EXTERNAL')"
      />
    </div>
  </div>

  <TrainingMinistrantesSection
    v-if="instructor.mode.value === 'INTERNAL'"
    :ministrantes="instructor.internal"
    :members="members"
    :member-options="memberOptions"
  />

  <template v-if="instructor.mode.value === 'EXTERNAL'">
    <div class="flex flex-col gap-3 border-b border-gray-02 px-6 py-8">
      <span
        id="open-training-instructor-external-type-label"
        class="text-sm font-semibold text-gray-07"
      >Ministrante Externo:</span>
      <div
        class="flex gap-8"
        aria-labelledby="open-training-instructor-external-type-label"
      >
        <IconRadio
          data-testid="open-training-instructor-external-individual"
          :model-value="instructor.externalType.value ?? undefined"
          value="EXTERNAL_INDIVIDUAL"
          label="Pessoa Física"
          name="open-training-instructor-external-type"
          @update:model-value="instructor.setExternalType('EXTERNAL_INDIVIDUAL')"
        />
        <IconRadio
          data-testid="open-training-instructor-external-company"
          :model-value="instructor.externalType.value ?? undefined"
          value="EXTERNAL_COMPANY"
          label="Pessoa Jurídica"
          name="open-training-instructor-external-type"
          @update:model-value="instructor.setExternalType('EXTERNAL_COMPANY')"
        />
      </div>
    </div>

    <OpenTrainingExternalIndividualSection
      v-if="instructor.externalType.value === 'EXTERNAL_INDIVIDUAL'"
      :form="instructor.externalIndividual"
    />
    <OpenTrainingExternalCompanySection
      v-if="instructor.externalType.value === 'EXTERNAL_COMPANY'"
      :form="instructor.externalCompany"
    />
  </template>
</template>
